export default class ReimboursedCapitalVariation {

	constructor(id, paymentDateIndex, reimboursedCapital) {
		this.id                 = id
		this.paymentDateIndex   = paymentDateIndex
		this.reimboursedCapital = reimboursedCapital
	}
	
	static createFromJson(json) {
		if (!json) return null;
		return new ReimboursedCapitalVariation(json.id, json.paymentDateIndex, json.reimboursedCapital);
	}
}


// WEBPACK FOOTER //
// ./src/model/reimboursed-capital-variation.js